"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const layout_css_1 = __importDefault(require("../../styles/global_ui/layout.css"));
const typography_css_1 = __importDefault(require("../../styles/global_ui/typography.css"));
const base_1 = __importDefault(require("../../client/buttons/base"));
const SurveyList_1 = __importDefault(require("../../client/reusable_components/Survey/SurveyList"));
const c = {
    header: `${typography_css_1.default.h2Responsive}`,
    container: `${layout_css_1.default.flexColumn} ${layout_css_1.default.gutter30}`,
};
const SurveysTab = ({ isRegistered, surveys }) => {
    const [showSurvey, setShowSurvey] = (0, react_1.useState)(false);
    const [remainingSurveys, setRemainingSurveys] = (0, react_1.useState)(surveys.filter(({ taken_survey }) => !taken_survey));
    const handleOnComplete = ({ remainingSurveys }) => {
        setRemainingSurveys(remainingSurveys);
    };
    return (react_1.default.createElement("div", { className: c.container },
        react_1.default.createElement("h2", { className: c.header }, "Survey Questionnaire"),
        !isRegistered
            ? (react_1.default.createElement("p", null, "You need to register for this Giveaway before you can start earning entries."))
            : (react_1.default.createElement(react_1.default.Fragment, null, remainingSurveys.length === 0
                ? (react_1.default.createElement("p", null,
                    "There are no surveys available at the moment. Check back later for more opportunities to earn extra entries.",
                    ' '))
                : showSurvey
                    ? (react_1.default.createElement(SurveyList_1.default, { onComplete: handleOnComplete, surveys: surveys }))
                    : (isRegistered && (react_1.default.createElement("div", { className: c.container },
                        react_1.default.createElement("p", null, "Take this survey to earn extra entries into this giveaway!"),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(base_1.default, { onClick: () => setShowSurvey(!showSurvey), size: "md" }, "Start Survey")))))))));
};
exports.default = SurveysTab;
